import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const urlPrefix = ''; // todo : 改为配置
// 病症报告
const AiSympReportPage = () =>
    import ('@/pages/aisympreport/AiSympReportPage.vue');
const HelpCenterPage = () =>
    import ('@/pages/helpcenter/HelpCenterPage.vue');
const BindEquipmentPage = () =>
    import ('@/pages/helpcenter/bindequipment/BindEquipmentPage.vue');
// 资讯页面
const InformationPage = () =>
    import ('@/pages/information/InformationPage.vue')

const ECGDetectPage = () =>
    import ('@/pages/helpcenter/ECGdetect/ECGDetectPage.vue');

const ThreeInspectionPage = () =>
    import ('@/pages/helpcenter/ThreeInspection/ThreeInspectionPage');

export default new Router({
    mode: 'history',
    routes: [{
            path: urlPrefix + '/ai_symp_report',
            name: 'AiSympReportPage',
            title: '病症AI分析报告',
            component: AiSympReportPage
        },
        {
            path: urlPrefix + '/help_center',
            name: 'HelpCenterPage',
            title: '帮助中心',
            component: HelpCenterPage
        },
        {
            path: '/bind_equipment',
            name: 'BindEquipment',
            title: '绑定设备',
            component: BindEquipmentPage
        },
        {
            path: '/ECG_detect',
            name: 'ECGDetect',
            title: '绑定设备',
            component: ECGDetectPage
        },
        {
            path: '/Three_inspection',
            name: 'ThreeInspection',
            title: '绑定设备',
            component: ThreeInspectionPage
        },
        {
            path: urlPrefix + '/information',
            name: 'InformationPage',
            title: '健康咨询',
            component: InformationPage
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js